import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Select from 'react-select';
import 'react-select/dist/react-select.css';
import './BizSelect.css';

class BizSelect extends Component {
  state = {
    selectedOption: null,
  };

  handleChange = (selectedOption) => {
    this.setState({ selectedOption });
    if (selectedOption) {
      if (this.props.multi) {
        this.props.onChange(selectedOption.map((entry) => (entry.value)));
      } else {
        this.props.onChange(selectedOption.value);
      }
    } else {
      this.props.onChange(null);
    }
  };

  render() {
    const { selectedOption } = this.state;
    const { multi, options, theme, name, placeholder, disabled } = this.props;
    let selectClass = 'biz-react-select';
    if (theme) selectClass = `${selectClass} biz-theme-${theme}`;
    return (
      <Select
        className={selectClass}
        value={selectedOption}
        onChange={this.handleChange}
        options={options}
        multi={multi}
        name={name}
        placeholder={placeholder}
        disabled={disabled}
      />
    );
  }
}

BizSelect.getDerivedStateFromProps = (nextProps) => {
  if (nextProps.value) {
    // For multi select
    if (nextProps.multi) {
      const selectedOptions = [];
      nextProps.value.forEach((val) => {
        for (let i = 0; i < nextProps.options.length; i++) {
          if (val === nextProps.options[i].value) {
            selectedOptions.push(nextProps.options[i]);
            break;
          }
        }
      });

      return {
        selectedOption: selectedOptions,
      };
    }

    // For single select
    for (let i = 0; i < nextProps.options.length; i++) {
      if (nextProps.value === nextProps.options[i].value) {
        return {
          selectedOption: nextProps.options[i],
        };
      }
    }
  }
  return {
    selectedOption: null,
  };
};

BizSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  multi: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  })).isRequired,
  theme: PropTypes.oneOf([null, 'lac', 'pa', 'ta', 'dac', 'crm']),
  name: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.oneOf([
      PropTypes.string,
      PropTypes.number,
    ])),
  ]),
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
};

BizSelect.defaultProps = {
  multi: false,
  theme: null,
  name: null,
  placeholder: 'Select...',
  value: null,
  disabled: false,
};

export default BizSelect;



// WEBPACK FOOTER //
// ./src/components/UI/BizSelect.jsx